import { zEmptyStringOrNull } from '@/general/src/other/validation.js'

import { normalizePhone } from 'svag-utils'
import { z } from 'zod'
import { zStringRequired } from './validation.js'

export const zPhoneRequired = zStringRequired
  .regex(
    // allow numbers, spaces, dashes, brackets, plus sign
    /^[\d\s-()+]+$/,
    'Неверный номер телефона'
  )
  .superRefine((val, ctx) => {
    const phone = val.replace(/\D/g, '')
    if (phone.startsWith('7') || phone.startsWith('8')) {
      if (phone.length !== 11) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Должно быть 11 цифр в номере',
        })
      }
    } else {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Номер должен быть российским и начинаться либо с 7, либо с 8',
      })
      // if (phone.length < 3) {
      //   ctx.addIssue({
      //     code: z.ZodIssueCode.custom,
      //     message: 'Неверный номер телефона',
      //   })
      // }
      // if (!validatePhone(phone)) {
      //   ctx.addIssue({
      //     code: z.ZodIssueCode.custom,
      //     message: 'Invalid phone number',
      //   })
      // }
    }
  })
  .transform((val) => normalizePhone(val))
export const zPhoneOptionalNullable = z.union([zEmptyStringOrNull, zPhoneRequired]).transform((val) => val || null)

export const getPhoneCode = (phone: string) => {
  return phone.replace(/\D/g, '').slice(1, 4)
}

export const getPhoneBody = (phone: string) => {
  phone = phone.replace(/\D/g, '')
  return phone.slice(4, 11)
}

export const getPhoneRichFormatWithBrackets = (phone: string) => {
  phone = phone.replace(/\D/g, '')
  const code = phone.slice(1, 4)
  return `+7 (${code}) ${phone.slice(4, 7)}-${phone.slice(7, 9)}-${phone.slice(9, 11)}`
}

export const getPhoneRichFormatWithoutBrackets = (phone: string) => {
  phone = phone.replace(/\D/g, '')
  const code = phone.slice(1, 4)
  return `+7 ${code} ${phone.slice(4, 7)}-${phone.slice(7, 9)}-${phone.slice(9, 11)}`
}
